import { CloseButton, Flex, Spacer, Text } from '@zillow/constellation';
import { Col } from '@zg-rentals/zrs-comet';
import MultiSelect from '../multiselect';

import { StyledPill } from './StyledComponents';
import type { AdvancedTableFilterOption } from '../AdvancedTable';

type MultiSelectFilterPillProps = {
  handleChange: (value: Array<AdvancedTableFilterOption>) => void;
  handleClearFilter: (value: Array<AdvancedTableFilterOption>) => void;
  isFilterOpen?: boolean;
  title?: string;
  value?: Array<AdvancedTableFilterOption>;
};

const MultiSelectFilterPill = ({
  handleChange = () => {},
  handleClearFilter,
  isFilterOpen = false,
  title = '',
  value = [],
}: MultiSelectFilterPillProps) => {
  if (value.length < 1) return null; // Don't display filters for less than 1 value
  let activeLength = 0;
  value.forEach((v) => {
    if (v.isChecked) activeLength += 1;
  });
  if (!isFilterOpen && activeLength === 0) return null;

  const handleClearOptions = () => {
    const newValues = value.slice(0); // fastest array copy
    newValues.forEach((v) => {
      v.isChecked = false;
    });
    handleClearFilter(newValues);
  };

  if (isFilterOpen) {
    return (
      <Col sm={12} md={6} lg={4}>
        <Spacer marginY="xs">
          <MultiSelect
            label={title}
            onChange={(i, newValue) => {
              const newOptions = [
                ...value.slice(0, i),
                {
                  ...value[i],
                  isChecked: newValue,
                },
                ...value.slice(i + 1),
              ];
              handleChange(newOptions);
            }}
            options={value}
          />
        </Spacer>
      </Col>
    );
  }
  return (
    <Col sm={6} md={4}>
      <StyledPill padding="sm" margin="xs">
        <Flex display="flex" justifyContent="space-between">
          <div>
            <Text as="div" fontType="bodySmallHeading">
              {title}
            </Text>
            <Text as="div" fontType="bodySmall">{`(${activeLength}) selected`}</Text>
          </div>
          <div onClick={handleClearOptions} className="BillingFilterPill-close">
            <CloseButton />
          </div>
        </Flex>
      </StyledPill>
    </Col>
  );
};

export default MultiSelectFilterPill;
